import { Reveal, MaskLine } from "./Reveal";

const ITEMS = [
  ["Carte de remerciement", "Un mot signé glissé dans chaque commande."],
  ["Papier de soie & pochette", "Votre flacon emballé comme un présent."],
  ["Sticker monogramme V", "Le sceau discret de la maison."],
  ["Fiche notes olfactives", "Tête, cœur, fond — et nos conseils d'utilisation."],
];

export const Experience = () => (
  <section id="experience" className="bg-ivory py-24 sm:py-32">
    <div className="wrap">
      <div className="max-w-2xl">
        <Reveal>
          <p className="eyebrow flex items-center gap-4 text-champagne">
            <span className="h-px w-10 bg-champagne" />
            L'expérience Vāsam
          </p>
        </Reveal>
        <MaskLine className="mt-5">
          <h2 className="font-serif text-4xl leading-[1.05] text-espresso sm:text-5xl">
            Bien plus <em className="italic text-taupe">qu'un parfum</em>
          </h2>
        </MaskLine>
        <Reveal delay={0.15}>
          <p className="mt-5 text-[15px] leading-relaxed text-espresso/70">
            Chaque commande est préparée comme un présent — parce qu'acheter un parfum, c'est offrir une expérience.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map(([title, text], i) => (
          <Reveal key={title} delay={i * 0.08}>
            <div className="border-t border-espresso/15 pt-6">
              <span className="font-serif text-2xl italic text-champagne">0{i + 1}</span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-espresso">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-espresso/65">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
